import React from "react"
import types from "prop-types"
import { dynamicRangeSurveysExample, weekRangeSurveyInclusionDescription } from "utils/scheduledReportExportHelpers"

const WeeksSurveyDateDescription = ({ startDate, surveySentPreviousRangeLength = null }) => {
  const weekCount = surveySentPreviousRangeLength || 1

  const beginningWeek = startDate.subtract(weekCount, "w")
  const beginningDate = beginningWeek.weekday(0)

  // endingDate is n weeks from start date minus one day
  const endingDate = beginningDate.add(weekCount, "w").subtract(1, "d")

  return (
    <div className="text-xs text-dark mt-2">
      <p className="mb-4">
        {weekRangeSurveyInclusionDescription}
      </p>
      <p>
        {dynamicRangeSurveysExample({ startDate, beginningDate, endingDate })}
      </p>
    </div>
  )
}

WeeksSurveyDateDescription.propTypes = {
  startDate: types.object.isRequired,
  surveySentPreviousRangeLength: types.number,
}

export default WeeksSurveyDateDescription
